import lflHeader from './lfl-header.vue'
import lflFooter from './lfl-footer.vue'
import lflIcon from './lfl-icon.vue'
import lflNull from './lfl-null.vue'

import scoreHeader from './score-header.vue'
import scoreCircleList from './score-circle-list.vue'
import scoreHotList from './score-hot-list.vue'
import scorePost from './score-post.vue'
import scoreNull from './score-null.vue'
import scoreAudio from './score-audio.vue'
import AudioBox from './AudioBox.vue'

// import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { Carousel3d, Slide } from 'vue-carousel-3d'
import vueSlider from 'vue-slider-component'

export default {
	lflHeader,
	lflFooter,
	lflNull,
	lflIcon,
	
	scoreHeader,
	scoreCircleList,
	scoreHotList,
	scorePost,
	scoreNull,
	scoreAudio,
	AudioBox,
	
	// VuePerfectScrollbar,
	Carousel3d,
	Slide,
	vueSlider,
	
}


// WEBPACK FOOTER //
// ./src/components/index.js